module.exports = __webpack_public_path__ + "img/logo-header.14f49f69.png";